import { getDecodedAppInstance } from 'wix-application';

/**
 *@function
 *@description Returns the subscription of the user. Only use for freemium apps, do not use for trial apps.
 *@returns json
 */
export async function getSubscription() {
    let instance = await getDecodedAppInstance();
    console.log("instance", instance);
    return {
        instance: instance,
        appId: instance.appDefId,
        instanceId: instance.instanceId,
        plan: instance.vendorProductId,
        isPremium: instance.vendorProductId != null,
        upgradeUrl: formatUpgradeUrl(instance.appDefId, instance.instanceId),
        reviewUrl: formatReviewUrl(instance.appDefId),
    };
}

export function formatUpgradeUrl(appId, instanceId) {
    return `https://www.wix.com/apps/upgrade/${appId}?appInstanceId=${instanceId}`;
}

export function formatReviewUrl(appId) {
    return `https://www.wix.com/app-market/add-review/${appId}`;
}